<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Benutzer Bearbeiten</h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link to="/management/users/list" class="mb-0 btn bg-gradient-success btn-sm"
                    >&nbsp; Zurück zur Übersicht</router-link
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <label class="form-label mt-2 row mt-4">Name</label>

            <soft-model-input
              id="name"
              v-model="user.name"
              type="text"
              placeholder="Name des Benutzers"
            />
            <validation-error :errors="apiValidationErrors.name" />

            <label class="form-label mt-2 row mt-4">Email</label>
            <soft-model-input
              id="email"
              v-model="user.email"
              type="text"
              placeholder="Email"
            />
            <validation-error :errors="apiValidationErrors.email" />

            <label class="form-label mt-2 row mt-4">Role</label>
            <select
              id="choices-roles"
              v-model="getRole"
              class="form-control"
              name="choices-roles"
            ></select>
            <validation-error :errors="apiValidationErrors.roles" />

            <label class="form-label mt-2 row mt-4">Affiliated von</label>
            <input
                id="affiliate"
                class="form-control"
                type="text"
                :value="affiliate.name"
                disabled
            />

            <soft-button
                color="danger"
                variant="gradient"
                class="float-start mt-4 mb-0"
                size="sm"
                :is-disabled="loading ? true : false"
                @click="resetPasswordAction"
            ><span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else>Passwort Zurücksetzen</span></soft-button
            >

            <soft-button
              color="success"
              variant="gradient"
              class="float-end mt-4 mb-0"
              size="sm"
              :is-disabled="loading ? true : false"
              @click="editUser"
              ><span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else>Speichern</span></soft-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftModelInput from "/src/components/SoftModelInput.vue";
import SoftButton from "/src/components/SoftButton.vue";
import showSwal from "/src/mixins/showSwal.js";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "/src/mixins/form-mixin.js";
import Choices from "choices.js";
import resetPassword from "@/views/auth/reset/ResetPassword.vue";

export default {
  name: "EditUser",
  components: {
    SoftModelInput,
    SoftButton,
    ValidationError,
  },
  mixins: [formMixin],
  data() {
    return {
      file: null,
      user: {},
      loading: false,
      getRole: null,
      options: [],
      affiliate: {},
    };
  },
  computed: {
    resetPassword() {
      return resetPassword
    },
    roles() {
      var response = [
        {
          value: "Admin",
          label: "Admin",
          id: 2,
        },
        {
          value: "User",
          label: "User",
          id: 1,
        },
        {
          value: "Gruppenleiter",
          label: "Gruppenleiter",
          id: 57,
        }
      ]
      switch (this.profile.scope) {
        case 1:
          response = [];
          break;
        case 2:
          break;
        case 57:
          response = response.filter((obj) => {
            return obj.value === "User";
          });
          break;
      }
      return response;
    },
    profile() {
      return this.$store.getters["profile/profile"];
    },
    preview() {
      if (this.file) return URL.createObjectURL(this.file);
      else if (this.user.profile_image) return this.user.profile_image;
      else return require("/src/assets/img/placeholder.jpg");
    },
  },
  async mounted() {
    this.user = await this.$store.dispatch("users/getUser", this.$route.params.id);
    this.user = this.user.data.data;
    this.affiliate = await this.$store.dispatch("users/getUser", this.user.ausbilderId);
    this.affiliate = this.affiliate.data.data;
    console.log('user', this.user)

    if (document.getElementById("choices-roles")) {
      var element = document.getElementById("choices-roles");
      new Choices(element, {
        searchEnabled: false,
        choices: [
          {
            value: "",
            label: "",
            selected: true,
            disabled: true,
          },
        ].concat(this.roles),
      }).setChoiceByValue((this.getRole = this.returnGroupName(this.user.scope)));
    }
  },
  methods: {
    async editUser() {
      this.resetApiValidation();
      this.loading = true;

      const id = this.roles.filter((obj) => {
        return obj.value === this.getRole;
      })[0]?.id;

      if (id)
        this.user.roles = [
          {
            type: "roles",
            id: id,
          },
        ];

      try {
        const editForm = {
          id: this.user.id,
          email: this.user.email,
          name: this.user.name,
          scope: this.returnScopeIdByName(this.getRole),
        }
        await this.$store.dispatch("users/editUser", editForm);
        showSwal.methods.showSwal({
          type: "success",
          message: "User edited successfully!",
        });
        this.$router.push("/management/users/list");
      } catch (error) {
        if (error.response.data.errors) this.setApiValidation(error.response.data.errors);
        else
          showSwal.methods.showSwal({
            type: "error",
            message: "Benutzer konnte nicht aktualisiert werden!",
            width: 350,
          });
        this.loading = false;
      }
    },
    async resetPasswordAction() {
      try {

        const response = await this.$store.dispatch("users/resetPassword", this.user.id);
        showSwal.methods.showSwal({
          type: "success",
          message: response.data.data,
        });
        this.$router.push("/management/users/list");
      } catch (error) {
        if (error.response.data.errors) this.setApiValidation(error.response.data.errors);
        else
          showSwal.methods.showSwal({
            type: "error",
            message: error.response.data.data,
            width: 350,
          });
        this.loading = false;
      }
    },
    addedImage(files) {
      this.file = files[0];
    },
    returnGroupName(scopeId) {
      switch (scopeId) {
        case 1:
          return "User";
        case 2:
          return "Admin";
        case 57:
          return "Gruppenleiter";
        default:
          return "User";

      }
    },
    returnScopeIdByName(scopeName) {
      switch (scopeName) {
        case "User":
          return 1;
        case "Admin":
          return 2;
        case "Gruppenleiter":
          return 57;
        default:
          return 1;
      }
    },
  },
};
</script>
<style>
img {
  object-fit: cover;
}

.choices{
  margin-bottom: 0px !important;
}
</style>
